import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import { useNavigate } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";
import ImagePath from "../../../constants/ImagePath";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyname, setkeyname] = useState("");
  const registerid = sessionStorage.getItem("registerid");

  const pathname = location.pathname;

  const getActiveTab = () => {
    if (pathname === "/") return "Flow";
    if (pathname.includes("/CardCourses")) return "Courses";
    if (pathname.includes("/HomeScreen")) return "homeScreen";
    if (pathname.includes("/Industry")) return "Industry";
    if (pathname.includes("/SettingsMainScreen")) return "settingMainScreen";
    return "";
  };

  const activeTab = getActiveTab();

  // Navigation to screens
  const expertscreen = (keyname) => {
    setkeyname(keyname);
    if (keyname == "Flow") {
      navigate("/");
    } else if (keyname == "Courses") {
      navigate("/CardCourses");
    } else if (keyname === "homeScreen") {
      navigate("/HomeScreen");
    } else if (keyname === "Industry") {
      navigate("/Industry");
    } else if (keyname === "settingMainScreen") {
      // if (registerid === null) {
      //   navigate("/", {
      //     state: true,
      //   });
      // } else {
        navigate("/SettingsMainScreen/SettingNotification");
      }
    // }
  };

  return (
    <footer
      style={{
        backgroundColor: "#F5F3EE",
        boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.2)", // Shadow at the top
      }}
      className="py-3 fixed-bottom"
    >
      <Container>
        <Row className="text-center">
          <Col>
            <div
              onClick={() => expertscreen("Flow")}
              // className="text-dark text-decoration-none d-flex flex-column align-items-center"
              className="text-dark d-flex flex-column align-items-center"
              style={{ cursor: "pointer" }}
            >
               <div
                className={`w-8 h-1 rounded-full mb-1 ${
                  activeTab === "Flow" ? "bg-black" : "bg-transparent"
                }`}
              />
              {/* <i className="bi bi-house-fill fs-4"></i> */}
              <img className="size-5" src={ImagePath.HomeImg} alt="Flow" />
            </div>
          </Col>
          <Col>
            <div
              onClick={() => expertscreen("Courses")}
              // className="text-dark text-decoration-none d-flex flex-column align-items-center"
               className="text-dark d-flex flex-column align-items-center"
              style={{ cursor: "pointer" }}
            >
                <div
                className={`w-8 h-1 rounded-full mb-1 ${
                  activeTab === "Courses" ? "bg-black" : "bg-transparent"
                }`}
              />
              {/* <i className="bi bi-award-fill fs-4"></i> */}
              <img className="size-5" src={ImagePath.courseimg} alt="Course" />
            </div>
          </Col>

          <Col>
            <div
              onClick={() => expertscreen("homeScreen")}
              // className="text-dark text-decoration-none d-flex flex-column align-items-center"
               className="text-dark d-flex flex-column align-items-center"
              style={{ cursor: "pointer" }}
            >
              <div
                className={`w-8 h-1 rounded-full mb-1 ${
                  activeTab === "homeScreen" ? "bg-black" : "bg-transparent"
                }`}
              />
              {/* <i className="bi bi-house-fill fs-4"></i> */}
              <img className="size-6" src={ImagePath.tutors} alt="Home" />
            </div>
          </Col>

          <Col>
            <div
              onClick={() => expertscreen("Industry")}
              // className="text-dark text-decoration-none d-flex flex-column align-items-center"
                className="text-dark d-flex flex-column align-items-center"
              style={{ cursor: "pointer" }}
            >
            <div
                className={`w-8 h-1 rounded-full mb-1 ${
                  activeTab === "Industry" ? "bg-black" : "bg-transparent"
                }`}
              />  
              <img
                className="size-6"
                src={ImagePath.industryImg}
                alt="Industry"
              />
            </div>
          </Col>

          <Col>
            <div
              onClick={() => expertscreen("settingMainScreen")}
              // className="text-dark text-decoration-none d-flex flex-column align-items-center"
              className="text-dark d-flex flex-column align-items-center"
              style={{ cursor: "pointer" }}
            >
               <div
                className={`w-8 h-1 rounded-full mb-1 ${
                  activeTab === "settingMainScreen"
                    ? "bg-black"
                    : "bg-transparent"
                }`}
              />
              {/* <i className="bi bi-person-fill fs-4"></i> */}
              <img src={ImagePath.person} alt="account" className="size-6" />
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
